// action
import {
    GET_HOME_PAGE_WIDGET,
    GET_HOME_PAGE_WIDGET_FAIL,
    GET_HOME_PAGE_WIDGET_SUCCESS,
    GET_HOME_PAGE_WIDGET_RESET
} from '../action/getHomePageWidgetAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    data: {},
    message: ""
}

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_HOME_PAGE_WIDGET:
            return {
                ...state,
                apiState: "loading"
            }
        case GET_HOME_PAGE_WIDGET_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case GET_HOME_PAGE_WIDGET_SUCCESS:
            return {
                ...state,
                apiState: "success",
                data: action.response.data.data.result,
            }
        case GET_HOME_PAGE_WIDGET_RESET:
            return initialState
        default:
            return state
    }
}